import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import Switch from 'react-switch';
import common from 'constants/common';
import forms from 'constants/forms';
import Input from 'components/atoms/input';
import useOutsideClick from 'utils/useOutsideClick';
import EmrPopOut from './emrPopOut';

const Emr = ({ errors, setFieldValue, values }) => {
  const emr = [...forms.adminPanelsUser.userEdit.emr];
  const [emrOpen, setEmrPopOut] = useState(false);
  const onSetReadings = (value) => {
    setFieldValue('reports', value);
  };

  const ref = useRef();
  useOutsideClick(ref, () => {
    setEmrPopOut(false);
  });

  return (
    <div className="admin-patient-form-block">
      <span>EMR Details</span>
      <Row>
        {emr.map((field) => (
          <Col lg="6" md="6" sm="6" xs="12" key={field.id}>
            <Input {...field} />
            {errors[field.id] ? (
              <div className="input-error">{errors[field.id]}</div>
            ) : null}
          </Col>
        ))}
      </Row>
      <Row>
        <Col lg="6" md="6" sm="6" xs="12">
          <div className="admin-patient-edit-form-label">Billing</div>
          <div className="admin-patient-edit-form-readings">
            <div>{values.billing ? 'Yes' : 'No'}</div>
            <Switch
              className="evelyn-switch"
              onChange={(checked) => {
                setFieldValue('billing', checked);
              }}
              checked={!!values.billing}
              uncheckedIcon={false}
              checkedIcon={false}
              onHandleColor={common.commonColors.green}
              offHandleColor={common.commonColors.gray}
              onColor={common.commonColors.white}
              offColor={common.commonColors.white}
              handleDiameter={24}
              height={30}
              width={59}
              activeBoxShadow="0"
            />
          </div>
        </Col>
        <Col lg="6" md="6" sm="6" xs="12">
          <Input label="Billing Cycle" id="billingCycle" />
        </Col>
      </Row>
      <Row>
        <Col lg="6" md="6" sm="6" xs="12">
          <div className="admin-patient-edit-form-label">Readings</div>
          <div className="admin-patient-edit-form-readings">
            <div>{values.readingsFlag ? 'Yes' : 'No'}</div>
            <Switch
              className="evelyn-switch"
              onChange={(checked) => {
                setFieldValue('readingsFlag', checked);
              }}
              checked={!!values.readingsFlag}
              uncheckedIcon={false}
              checkedIcon={false}
              onHandleColor={common.commonColors.green}
              offHandleColor={common.commonColors.gray}
              onColor={common.commonColors.white}
              offColor={common.commonColors.white}
              handleDiameter={24}
              height={30}
              width={59}
              activeBoxShadow="0"
            />
          </div>
        </Col>
        <Col lg="6" md="6" sm="6" xs="12">
          <div ref={ref}>
            <div
              onClick={() => {
                setEmrPopOut(true);
              }}
            >
              <Input label="Report" id="reports" />
            </div>
            {emrOpen && <EmrPopOut onSetReadings={onSetReadings} />}
          </div>
        </Col>
      </Row>
    </div>
  );
};

Emr.propTypes = {
  errors: PropTypes.shape(),
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.shape(),
};

export default Emr;
